import React from 'react';
import PropType from 'prop-types';

import {
  Button, Card, CardBody, CardHeader, Collapse
} from 'reactstrap';

class CollapseBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: props.isOpen,
    };
  }

  toggle(e) {
    // let event = e.target.dataset.event;
    // this.setState({ collapse: this.state.collapse === Number(event) ? 0 : Number(event) });
    this.setState({ isOpen: !this.state.isOpen });
  }

  render() {
    const icon =
      !this.state.isOpen ? 'icon-plus' : 'icon-minus';

    return (
      <Card style={{ marginBottom: '1rem' }}>
        <CardHeader onClick={::this.toggle}><span className={icon}/> {this.props.title}</CardHeader>
        <Collapse isOpen={this.state.isOpen}>
          <CardBody>
            {this.props.children}
          </CardBody>
        </Collapse>
      </Card>
    );
  }
}

CollapseBox.defaultProps = {
  isOpen: false,
};

CollapseBox.propTypes = {
  title: PropType.string.isRequired,
  isOpen: PropType.bool.isRequired,
};

export default CollapseBox;


// WEBPACK FOOTER //
// ./src/components/CollapseBox/CollapseBox.js